import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { globalVariables } from "./globalVariables";

export const DEFAULT_DATE_FORMAT = "MM-DD-YYYY";
export const DOG_REGISTRATION_FEE = 40;
export const ROLE = {
  Member: "Member",
  Host: "Host",
  SuperAdmin: "Super Admin",
  Judge: "Judge",
};

export const useURLQuery = () => {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
};

export const roles = [ROLE.Member, ROLE.Host];

// export const roles = [ROLE.Member, ROLE.Host, ROLE.SuperAdmin];

export const DecoratedPrice = (value: number) => {
  const Currency = "$";
  return `${Currency}${value?.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}`;
};

export const LEVEL_DROPDOWN_DATA = [
  globalVariables.sit,
  globalVariables.novice,
  globalVariables.advanced,
  globalVariables.excellent,
  globalVariables.premier,
];
